import axios from 'axios';
import {getItem} from '../utils/storage';
import moment from 'moment-timezone';
import {getUniqueCalls} from '../utils/utils';
import { toast } from 'react-toastify';
import { getApiDomain } from '../agent/config';
import getV2AxiosInstance from '../utils/v2Axios.js';
import getGrapQLAxiosInstance from "../utils/graphQLAxios.js";


/**
 * returns response or error of api call
 * @param  {object} response [response of api call]
 * @return {object}          [response or error]
 */
function handleResponse(response){
  if(response.status==200){
    return response;
  }else{
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

/**
 * makes outgoing call
 * @param  {object} payload
 */
export function makeOutgoingCall(payload, internalCall = false){
    return (dispatch, getState) => {
      const state = getState();
       if (state.agentInfo.max_call_tabs != 0 && getUniqueCalls(state.callEvents.events) >= state.agentInfo.max_call_tabs && !internalCall){
        return new Promise((resolve, reject) => {
          reject('maxTabError');
        })
        //toast.error(state.languages.translations.maxTabError[state.languages.selectedLanguage], {autoClose: false});
      } else {
        return getV2AxiosInstance().post("/bridge/en/invoxapi/Call", {
          action: "call",
          params: { agent_id: localStorage.getItem("agent_id"),
          from: payload.extension,
          to: payload.phone,
          'options[autoanswer]': 1,
          'options[service_id]': payload.service_id, },
        }).then(handleResponse);
       };
    }
}

export function postRescheduleCall(payload){
    return dispatch => {
     // console.log(payload)
      return getV2AxiosInstance()
      .post("/api/en/invoxapi/autodialerrecord", {"data": payload}).then(handleResponse)
    };
}
export function patchRescheduleCall(payload,listDetailId){
    return dispatch => {
      return getV2AxiosInstance()
      .patch(`api/en/invoxapi/autodialerrecord/${listDetailId}`, payload).then(handleResponse)
    };
}

export function getCallUrl(call_id, service_id, to, from, autodialer_id, type){
    return dispatch => {
      return getV2AxiosInstance().post("/bridge/en/invoxapi/Service", {
        action: "getServiceUrlByCallId",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          call_id,
          service_id,
          to,
          from,
          autodialer_id,
          type,
        },
      });
    };
}

export function setTabLock() {
  return (dispatch, getState) => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Agent", {
        action: "setTabLock",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          num_tabs: getUniqueCalls(getState().callEvents.events),
        },
      })
      .then(handleResponse);
  };
}

export function startRecording(call_id){
    return dispatch => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Call", {
        action: "startRecordByCallId",
        params: {
          call_id: call_id,
        },
      }).then(handleResponse)
    };
}

export function stopRecording(call_id){
    return dispatch => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Call", {
        action: "stopRecordByCallId",
        params: {
          call_id: call_id,
        },
      }).then(handleResponse)
    };
}

export function listenToCall(payload) {
  return async (dispatch) => {
    try {
      const { data } = await getV2AxiosInstance().post(
        "/bridge/en/invoxapi/Call",
        {
          action: "whisper",
          params: {
            call_id: payload.call_id,
            extension: payload.extension,
            type: payload.whisper_type,
          },
        }
      );
      return handleResponse(data);
    } catch (error) {
      console.error("listenToCall request failed:", error);
      throw error;
    }
  };
}


export function hangupCall(call_id){
    return dispatch => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Call", {
        action: "hangupCall",
        params: {
          'options[call_id]': call_id
        },
      })
      .then(handleResponse);
    };
}

export function setCallUrlData(data){
  return dispatch => {
     return dispatch({
         type: 'SET_CALL_URL_DATA',
         payload: data
     });
  };
}

export function addCallEvent(data){
  return dispatch => {
     return dispatch({
         type: 'ADD_CALL_EVENT',
         payload: data
     });
  };
}

export function updateCallEvent(data){
  return dispatch => {
     return dispatch({
         type: 'UPDATE_CALL_EVENT',
         payload: data
     });
  };
}

export function deleteCallEventData(data){
  return dispatch => {
     dispatch({
         type: 'DELETE_CALL_EVENT',
         payload: data
     });
  };
}

export function deleteCallEvent(data){
  return dispatch => {
     dispatch(deleteCallEventData(data));
     setTimeout(() => {
       dispatch(setTabLock());
     }, 100);
  };
}

export function deleteCallEventsData(data){
  return dispatch => {
     dispatch({
         type: 'DELETE_CALL_EVENTS',
         payload: data
     });
  };
}

export function deleteCallEvents(data){
  return dispatch => {
     dispatch(deleteCallEventsData(data));
     setTimeout(() => {
       dispatch(setTabLock());
     }, 100);
  };
}

export function incomingTerminated(data){
  return dispatch => {
     return dispatch({
         type: 'INCOMING_TERMINATED',
         payload: data
     });
  };
}

export function incomingMissed(data, timezone){
  data.data.time = moment.tz(timezone).format('DD/MM/YYYY HH:mm')
  return dispatch => {
     return dispatch({
         type: 'INCOMING_MISSED',
         payload: data
     });
  };
}

export function removeNotification(id) {
  return dispatch => {
    return dispatch({
      type: 'NOTIFICATION_REMOVE',
      payload: id
    })
  }
}

export function notificationOpened(){
  return dispatch => {
     return dispatch({
         type: 'NOTIFICATION_OPENED',
         payload: 0
     });
  };
}

export function callStarted(data){
  return dispatch => {
     return dispatch({
         type: 'CALL_STARTED',
         payload: data
     });
  };
}

export function callAnswered(data){
  return dispatch => {
    dispatch({
      type: 'CALL_ANSWERED',
      payload: data
    });
    dispatch({
      type: 'CALL_ANSWERED_ID_UPDATE',
      payload: data.data.id
    });
  };
}

export function outgoingTerminated(data){
  return dispatch => {
     return dispatch({
         type: 'OUTGOING_TERMINATED',
         payload: data
     });
  };
}

export function reopenTab(data){
  return dispatch => {
     return dispatch({
         type: 'REOPEN_TAB',
         payload: data
     });
  };
}

export function reActivateTab(data){
  return dispatch => {
     return dispatch({
         type: 'REACTIVATE_TAB',
         payload: data
     });
  };
}

export function changeServiceName(data){
  return dispatch => {
     return dispatch({
         type: 'CHANGE_SERVICE_NAME',
         payload: data
     });
  };
}

export function modifyCall(data){
  return dispatch => {
     return dispatch({
         type: 'MODIFY_CALL',
         payload: data
     });
  };
}

export function fullScreenChange(data){
  return dispatch => {
     return dispatch({
         type: 'FULL_SCREEN_CHANGE',
         payload: data
     });
  };
}

export function doCall(phoneNumber){
  return dispatch => {
     return dispatch({
         type: 'MAKE_CALL',
         payload: phoneNumber
     });
  };
}

export function resetCall(){
  return dispatch => {
     return dispatch({
         type: 'RESET_CALL',
         payload: ''
     });
  };
}

export function setResetActiveTab(resetActiveTab){
  return dispatch => {
     return dispatch({
         type: 'SET_RESET_ACTIVE_TAB',
         payload: resetActiveTab
     });
  };
}

export function queueCallJoin(payload){
  return dispatch => {
     return dispatch({
         type: 'QUEUE_CALL_JOIN',
         payload
     });
  };
}

export function modifyQueueCalls(payload){
  return dispatch => {
     return dispatch({
         type: 'QUEUE_CALL_MODIFY',
         payload
     });
  };
}

export function queueCallLeave(payload){
  return dispatch => {
     return dispatch({
         type: 'QUEUE_CALL_LEAVE',
         payload
     });
  };
}

export function queueCallNoAnswer(payload){
  return dispatch => {
     return dispatch({
         type: 'QUEUE_CALL_NO_ANSWER',
         payload
     });
  };
}

export function queueCallConnected(payload){
  return dispatch => {
     return dispatch({
         type: 'QUEUE_CALL_CONNECT',
         payload
     });
  };
}

export function showWebphone(show){
  return dispatch => {
     return dispatch({
         type: show ? 'OPEN_WEBPHONE' : 'CLOSE_WEBPHONE',
         payload: null,
     });
  };
}



// WEBPACK FOOTER //
// ./src/actions/call.js